<script setup lang="ts">
import ContentContainer from '@/components/layout/ContentContainer.vue';

defineProps<{
  title: string;
  subtext?: string;
  img?: string;
}>();
</script>

<template>
  <ContentContainer class="page-header">
    <div class="page-header-text">
      <h1 class="page-header-title">
        {{ title }}
      </h1>
      <div v-if="subtext" class="page-header-subtext">
        {{ subtext }}
      </div>
    </div>
    <NuxtImg
      v-if="img"
      class="page-header-image"
      :src="img"
      :alt="title"
      width="500"
    />
  </ContentContainer>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/shared/screen" as screen;

.page-header {
  display: flex;
  align-items: center;
  min-height: 36rem;
  border-top: 0.05rem solid var(--colour-black);
  border-bottom: 0.05rem solid var(--colour-black);
  background: var(--colour-off-white)
    url(@/assets/images/dot-square.svg) repeat top -1px center;

  @include screen.respond(tablet) {
    min-height: 23.4rem;
    background-size: 7.8rem;
  }

  :deep(.content-container) {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: var(--spacing-l);
    padding-bottom: var(--spacing-l);
  }
}

.page-header-title {
  margin-top: 0;
  margin-bottom: 0;
}
.page-header-subtext {
  margin-top: 2rem;
  color: var(--colour-dark-grey);
}

.page-header-image {
  display: block;
  margin: 0;
  height: calc(36rem - var(--spacing-l) - var(--spacing-l));
  width: auto;

  @include screen.respond(tablet) {
    display: none;
  }
}
</style>
